import { render, staticRenderFns } from "./Show-dados-empresa.vue?vue&type=template&id=5efa7cee&"
import script from "./Show-dados-empresa.vue?vue&type=script&lang=js&"
export * from "./Show-dados-empresa.vue?vue&type=script&lang=js&"
import style0 from "./Show-dados-empresa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports